import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table, Pagination } from "antd";
import axios from "axios";
import Breadcrumbs from "../../../components/Breadcrumbs";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import SearchBox from "../../../components/SearchBox";
import DepartmentModal from "../../../components/modelpopup/DepartmentModal";
import { base_url } from "../../../base_urls";
import {
  itemRender,
  pageSizeOptions,
  handlePageChange,
  defaultPagination
} from "utils/table";
import {getDepartment} from "api/services/common"
import { useSearchParams } from 'react-router-dom';
import { useMediaQuery } from "react-responsive";
import { SkeltonLoader } from "components/skeltonLoader";

import { Button } from "components/Button";
import { syncDataApi } from "api/services/settings";
import { toast , Bounce } from "react-toastify";



const Department = () => {
  const [departmentData, setDepartmentData] = useState([])
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [view, setView] = useState(isMobile? "grid":"list");


 

  const syncHandler = (type) => {
    setLoading(true)
    let payload = {
      data_sync_type: type
    }
    syncDataApi(payload).then((res) => {
      setLoading(false)
      console.log(res);
      toast.success(res?.data?.message || 'Sync request successfully sent', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });

    }).catch((err) => {
      setLoading(false)
      console.log(err);
      toast.error(err?.response?.data?.message || 'Something went wrong', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
    })

    console.log("syncHandler");
  }
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle="Sync Data"
            title="Settings"
            subtitle="Sync Data"
            // modal="#add_department"
            name="Sync Data"
            // view={view}
            // setView={setView}
          />
          {/* /Page Header */}
          <div className="row g-3">
            <div className="col-md-4">
              <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h5 className="card-title mb-1" style={{ fontSize: "18px", fontWeight: "600", color: "#333" }}>Sync All Data</h5>
                      <p className="text-muted mb-0" style={{ fontSize: "13px" }}>Synchronize all system data</p>
                    </div>
                    <div className="ms-3">
                      <i className="fa fa-sync-alt" style={{ fontSize: "32px", color: "#667eea" }}></i>
                    </div>
                  </div>
                  <Button
                    className="btn btn-primary w-100"
                    style={{ borderRadius: "8px", fontWeight: "500" }}
                    label="Sync Now"
                    onClick={() => syncHandler("all")}
                    loading={loading}
                    disabled={loading}
                  />
                </div>
              </div>
            </div>
           
            <div className="col-md-4">
              <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h5 className="card-title mb-1" style={{ fontSize: "18px", fontWeight: "600", color: "#333" }}>Sync Master Data</h5>
                      <p className="text-muted mb-0" style={{ fontSize: "13px" }}>Synchronize master configuration</p>
                    </div>
                    <div className="ms-3">
                      <i className="fa fa-database" style={{ fontSize: "32px", color: "#764ba2" }}></i>
                    </div>
                  </div>
                  <Button
                    className="btn btn-primary w-100"
                    style={{ borderRadius: "8px", fontWeight: "500" }}
                    label="Sync Now"
                    onClick={() => syncHandler("master")}
                    loading={loading}
                    disabled={loading}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h5 className="card-title mb-1" style={{ fontSize: "18px", fontWeight: "600", color: "#333" }}>Sync Employee Data</h5>
                      <p className="text-muted mb-0" style={{ fontSize: "13px" }}>Synchronize employee information</p>
                    </div>
                    <div className="ms-3">
                      <i className="fa fa-users" style={{ fontSize: "32px", color: "#f093fb" }}></i>
                    </div>
                  </div>
                  <Button
                    className="btn btn-primary w-100"
                    style={{ borderRadius: "8px", fontWeight: "500" }}
                    label="Sync Now"
                    onClick={() => syncHandler("user")}
                    loading={loading}
                    disabled={loading}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  );
};

export default Department;
